import axios from "axios";
export const AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        Authorization: `Bearer ${process.env.REACT_APP_API_KEY}`
    }
});